import { Box, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import React from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StoreInventory = () => {

  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [type, setType] = React.useState('default');
  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const [rows] = useState([
    {
      id: 1,
      name: "Chocolate Chips",
      status: false,
    },
    {
      id: 2,
      name: "Kiwi",
      status: true,
    },
    {
      id: 3,
      name: "Blackberries",
      status: false,
    },
  ]);

  const [rows2] = useState([
    {
      id: 1,
      name: "Strawberry",
      status: false,
    },
    {
      id: 2,
      name: "Mango",
      status: true,
    },
    {
      id: 3,
      name: "Vanilla",
      status: false,
    },
    {
      id: 4,
      name: "Blueberry",
      status: false,
    },
  ]);

  const [rows3] = useState([
    {
      id: 1,
      name: "GoGreek Cino",
      category: "Smoothies",
      status: false,
    },
    {
      id: 2,
      name: "GoGreek Cino",
      category: "Smoothies",
      status: true,
    },
    {
      id: 3,
      name: "Greek Frappe",
      category: "Beverages",
      status: false,
    },
    {
      id: 4,
      name: "Espresso",
      category: "Beverages",
      status: false,
    },
  ]);

  const [rows4] = useState([
    {
      id: 1,
      name: "Wild Berries",
      status: false,
    },
    {
      id: 2,
      name: "Bees",
      status: true,
    },
    {
      id: 3,
      name: "Lavender",
      status: false,
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Store Inventory - #ST001</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/manage-stores")}>Store Management</button> -
          Store Inventory
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Flavors" {...a11yProps(0)} />
              <Tab label="Toppings" {...a11yProps(1)} />
              <Tab label="Products" {...a11yProps(2)} />
              <Tab label="Box Art" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards view_page">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No</TableCell>
                  <TableCell>Flavor Name</TableCell>
                  <TableCell>Out of Stock</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows2.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Box component="a" className="user_block">
                        <figure>
                          <img src="/static/images/placeholder.png" alt="User" />
                        </figure>
                        <p>
                          <b>{row.name}</b>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <SwitchToggle checked={row.status} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No</TableCell>
                  <TableCell>Topping Name</TableCell>
                  <TableCell>Out of Stock</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Box component="a" className="user_block">
                        <figure>
                          <img src="/static/images/placeholder.png" alt="User" />
                        </figure>
                        <p>
                          <b>{row.name}</b>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <SwitchToggle checked={row.status} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
              <div className="form">
                <div className="control_group">
                  <Select
                    fullWidth
                    value={type}
                    onChange={handleTypeChange}
                  >
                    <MenuItem disabled value="default">Select Category</MenuItem>
                    <MenuItem value="1">Smothies</MenuItem>
                    <MenuItem value="2">Beverages</MenuItem>
                    <MenuItem value="3">Greek Bowl</MenuItem>
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No</TableCell>
                  <TableCell>Product Name</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Out of Stock</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows3.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Box component="a" className="click_action user_block" onClick={() => navigate('/manage-products/detail')}>
                        <figure>
                          <img src="/static/images/placeholder.png" alt="User" />
                        </figure>
                        <p>
                          <b>{row.name}</b>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>{row.category}</TableCell>
                    <TableCell>
                      <SwitchToggle checked={row.status} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No</TableCell>
                  <TableCell>Box Art Name</TableCell>
                  <TableCell>Out of Stock</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows4.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Box component="a" className="click_action user_block" onClick={() => navigate('/manage-products/detail')}>
                        <figure>
                          <img src="/static/images/placeholder.png" alt="User" />
                        </figure>
                        <p>
                          <b>{row.name}</b>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <SwitchToggle checked={row.status} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default StoreInventory;
